import { render, staticRenderFns } from "./SurveyOverview.vue?vue&type=template&id=351a89b0&scoped=true&"
import script from "./SurveyOverview.vue?vue&type=script&lang=js&"
export * from "./SurveyOverview.vue?vue&type=script&lang=js&"
import style0 from "./SurveyOverview.vue?vue&type=style&index=0&id=351a89b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a89b0",
  null
  
)

export default component.exports